import React, { useContext, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { AdminContext } from "../../context/AdminContext";
import AddBusinessName from "./AddBusinessName";
import WelcomeScreen from "./WelcomeScreen";
import AboutBusiness from "./AboutBusiness";
import DepartmentSelection from "./DepartmentSelection";
import AiSuggestedReports from "./AiSuggestedReports";
import useBusinessSubmit from "../../hooks/formSubmits/useBusinessSubmit";

export default function Index() {
  const location = useLocation();
  const { state } = useContext(AdminContext);
  const { adminInfo } = state;

  const [teamData, setTeamData] = useState({
    name: "",
    description: "",
    reg_channel: "web",
  });

  const [step, setStep] = useState(1);

  const handleClose = () => {
    setStep(5);
  };
  const { onSubmit, isLoading } = useBusinessSubmit({ handleClose });

  const handleCreateSubmit = async () => {
    await onSubmit(teamData);
  };

  if (!adminInfo) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: location },
        }}
      />
    );
  }
  return (
    <div>
      {step === 1 && <WelcomeScreen step={step} setStep={setStep} />}
      {step === 2 && (
        <AboutBusiness
          setStoreData={setTeamData}
          setStep={setStep}
          storeData={teamData}
        />
      )}
      {step === 3 && (
        <DepartmentSelection
          setStoreData={setTeamData}
          storeData={teamData}
          step={step}
          setStep={setStep}
        />
      )}
      {step === 4 && (
        <AddBusinessName
          setStoreData={setTeamData}
          storeData={teamData}
          step={step}
          setStep={setStep}
          onSubmit={handleCreateSubmit}
          isLoading={isLoading}
        />
      )}

      {step === 5 && (
        <AiSuggestedReports
          storeData={teamData}
          setStep={setStep}
          onComplete={() => ({})}
        />
      )}
    </div>
  );
}
